export const GRAPHQL_CLIENT_NAMES = {
  DELIVERY_ZONES: 'delivery_zones',
  BACKEND: 'backend',
  VERD: 'verd',
};
